<template>
    <div>
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="基本信息" name="basic"/>
            <el-tab-pane label="企业信息" name="enterprise"/>
            <el-tab-pane label="法人信息" name="legal"/>
            <el-tab-pane label="银行账户" name="bank"/>
        </el-tabs>

        <!--form表单-->
        <el-form size="small" ref="formData" :model="formData" label-width="150px">

            <!--基本信息-->
            <Basic v-show="activeName === 'basic'"/>
            <!--企业信息-->
            <Enterprise v-show="activeName === 'enterprise'"/>
            <!--法人信息-->
            <Legal v-show="activeName === 'legal'"/>
            <!--银行账户信息-->
            <Bank v-show="activeName === 'bank'"/>


            <!--提交-->
            <div class="common-button-wrapper">
                <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
            </div>
        </el-form>

        <!--签约弹窗-->
        <el-dialog center width="30%" :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" class="dialog-footer">
                <div class="dialog-title1">【线上协议签约】</div>
                <div class="dialog-title2">为保护账号安全，线上支付、分账、提现等涉及到交易的内容，需完成线上协议签约，未完成线上签约的商户无法正常使用支付、分账、提现等内容</div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="agreementClick()" :loading="loading">去签约</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import SettingApi from '@/api/setting.js';
    import Basic from './part/Basic.vue' // 基本信息
    import Enterprise from './part/Enterprise.vue' // 基本信息
    import Legal from './part/Legal.vue' // 法人信息
    import Bank from './part/Bank.vue' // 银行账户信息

    export default {
        components: {
            // 基本信息
            Basic,
            // 企业信息
            Enterprise,
            // 法人信息
            Legal,
            // 银行账户信息
            Bank
        },
        data() {
            return {
                activeName: 'enterprise',
                // 是否在提交
                loading: false,
                // 表单数据对象
                formData: {
                    name: '',
                    link_name: '',
                    link_phone: '',
                    address: '',
                    description: '',
                    logo_id: 0,
                    business_id:0,
                },
                dialogVisible: false,
                shop_supplier_id: '',
            }
        },
        provide: function () {
            return {
                formData: this.formData,
            }
        },
        created() {
            this.getParams();
        },
        methods: {

            /*获取配置数据*/
            getParams() {
                let that = this;
                SettingApi.getSupplier({}, true).then(res => {
                    Object.assign(that.formData, res.data.model)
                    this.agreementStatus = that.formData.agreementStatus

                    if (that.agreementStatus == 1) {
                        that.dialogVisible = true
                        that.shop_supplier_id = that.formData.shop_supplier_id
                    } else {
                        that.dialogVisible = false
                    }
                })
                    .catch(error => {

                    });
            },

            /*提交*/
            onSubmit() {
                let that = this;
                let params = this.formData;
                that.$refs.formData.validate((valid) => {
                    if (valid) {
                        that.loading = true;
                        SettingApi.setSupplier(params, true)
                            .then(data => {
                                that.loading = false;
                                that.$message({
                                    message: '恭喜你，保存设置成功',
                                    type: 'success'
                                });
                            })
                            .catch(error => {
                                that.loading = false;
                            });
                    }
                });

            },

            // 签约
            agreementClick() {
                let that = this;

                that.loading = true;
                SettingApi.agreementSupplier({
                    shop_supplier_id: that.shop_supplier_id
                }, true)
                    .then(res => {
                        that.loading = false;
                        if (res.code == 1) {
                            if (res.data.hasOwnProperty('signAgreementUrl')) {
                                // signAgreementUrl 收款方角色签订的相关协议签约地址
                                window.location.href = res.data.signAgreementUrl
                            } else {
                                // sepAgreementUrl 分账方角色签订的相关协议签约地址
                                window.location.href = res.data.sepAgreementUrl
                            }
                        }
                    })
                    .catch(error => {
                        that.loading = false;
                    });
            },

        }
    }
</script>

<style scoped>
    .dialog-title1{
        font-size: 24px;
        font-weight: bold;
    }
    .dialog-title2{
        font-size: 16px;
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/setting/supplier/index.vue